// FIXME: Update this configuration file based on your project information

export const AppConfig = {
	site_name: 'Cinestar',
	title: 'Cinestar - Hệ thống Rạp chiếu phim giá rẻ, hiện đại bậc nhất',
	description:
		'Hệ thống rạp chiếu phim Cinestar phục vụ khán giả với những thước phim điện ảnh chất lượng, dịch vụ tốt nhất với giá vé chỉ từ 45.000đ. Đặt vé ngay hôm nay để nhận được những ưu đãi bất ngờ từ Cinestar.',
	locale: 'vi'
}
